import { render, staticRenderFns } from "./ResultadosC3Section.vue?vue&type=template&id=08de3d5c&scoped=true"
import script from "./ResultadosC3Section.vue?vue&type=script&lang=js"
export * from "./ResultadosC3Section.vue?vue&type=script&lang=js"
import style0 from "./ResultadosC3Section.vue?vue&type=style&index=0&id=08de3d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08de3d5c",
  null
  
)

export default component.exports